define(function(require, exports, module) {
    return module.exports = window.kityminder.Minder;
});



// WEBPACK FOOTER //
// ./src/kityminder-editor/minder.js